import { useActiveOrganization } from '@/graphql/queries/organizations';
import { DangerZoneSettings } from '../components/danger-zone-settings';
import { Skeleton } from '@/components/ui-kit/skeleton';

const OrgDangerZonePage = () => {
  const { data: org, isLoading } = useActiveOrganization();

  if (isLoading) {
    return <Skeleton className="h-64 w-full" />;
  }

  if (!org) return null;

  return <DangerZoneSettings org={org} />;
};

export default OrgDangerZonePage;
